jQuery(document).ready(function ($) {
    function animateCounter($el) {
        var target = parseInt($el.data('target'));
        var current = 0;
        var speed = 20;
        var increment = Math.ceil(target / 50);

        var counter = setInterval(function () {
            current += increment;
            if (current >= target) {
                $el.text(target);
                clearInterval(counter);
            } else {
                $el.text(current);
            }
        }, speed);
    }

    function isInViewport($el) {
        var elementTop = $el.offset().top;
        var elementBottom = elementTop + $el.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    var $counters = $('.card-number_big');

    function checkCounters() {
        $counters.each(function () {
            var $this = $(this);
            if (!$this.hasClass('counted') && isInViewport($this)) {
                animateCounter($this);
                $this.addClass('counted');
            }
        });
    }

    $(window).on('scroll resize', checkCounters);
    checkCounters(); // Verifica ao carregar a página
});

